export default __webpack_public_path__ + "static/media/ETH.dc0a6bc5.svg";